<template>
  <div class="section section6">
    <div class="section-con">
      <img
        :src="emptyImage"
        class="fullpage-item-holder"
        style="display: inline;"
      />
      <div class="content-pos">
        <ul class="about-list up-ani">
          <li class="about-item">
            <span class="tap"></span>
            <a :href="contact.tapUrl" target="_blank" class="qrcode">
              <img :src="contact.tapQr" class="hcode" alt="ffbewotv" />
            </a>
          </li>
          <li class="about-item about-item-wx">
            <span class="bli"></span>
            <a :href="contact.bilibiliUrl" target="_blank" class="qrcode">
              <img :src="contact.bilibiliQr" class="hcode" alt="ffbewotv" />
            </a>
          </li>
          <li class="about-item">
            <span class="wz"></span>
            <a :href="contact.ngaUrl" target="_blank" class="qrcode">
              <img :src="contact.ngaQr" class="hcode" alt="ffbewotv" />
            </a>
          </li>
          <li class="about-item">
            <span class="wx"></span>
            <a class="qrcode">
              <img :src="contact.wxQr" class="hcode" alt="ffbewotv" />
            </a>
          </li>
          <li class="about-item">
            <span class="wb"></span>
            <a :href="contact.wbUrl" target="_blank" class="qrcode">
              <img :src="contact.wbQr" class="hcode" alt="ffbewotv" />
            </a>
          </li>
        </ul>
        <div class="contact up-ani">
          <div class="qq-box">
            <span class="qq"></span>
            <u class="qq-number">
              <li
                v-for="(item, index) in contact.qqList"
                :key="index"
                class="qq-item"
              >
                {{ item.qqName }}
              </li>
            </u>
          </div>
          <div class="kf-box">
            <span class="kf"></span>
            <span v-if="showChannel" class="mobile">028-85437733</span>
            <div class="kf-qr">
              <img :src="contact.kfQr" alt="ffbewotv" />
              <p class="kf-txt">扫码联系客服</p>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getEmptySVG } from "@/libs/svg";
import Footer from "@/components/Footer";

export default {
  name: "Section6",
  components: {
    Footer
  },
  data() {
    return {
      emptyImage: getEmptySVG(1920, 1080),
      showChannel: false
    };
  },
  computed: {
    ...mapState(["contact", "channel"])
  },
  mounted() {
    if (this.channel) {
      this.showChannel = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.logo {
  width: 2rem;
  height: 2rem;
}
.section6 {
  background: url("~@/assets/images/bg_06.jpg") no-repeat center top / cover;
  .about-list,
  .contact {
    margin: 0 auto;
  }
  .about-list {
    display: flex;
    justify-content: space-between;
    .mixin_com(width, 1080);
    .mixin_com(margin-top, 240);
  }
  .about-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .mixin_com(width, 172);
    .mixin_com(height, 172);

    background-color: rgba(65, 29, 19, 0.95);
    .qrcode {
      .transform(scale(0));

      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transition: all 0.4s ease;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &:hover {
      .qrcode {
        .transform(scale(1));
      }
    }
    .tap {
      .mixin_com(width, 139);
      .mixin_com(height, 78);

      background:
        url("~@/assets/images/section6/tap.png") no-repeat center top /
        100%;
    }
    .bli {
      .mixin_com(width, 109);
      .mixin_com(height, 102);

      background:
        url("~@/assets/images/section6/bli.png") no-repeat center top /
        100%;
    }
    .wz {
      .mixin_com(width, 99);
      .mixin_com(height, 125);

      background:
        url("~@/assets/images/section6/wz.png") no-repeat center top /
        100%;
    }
    .wx {
      .mixin_com(width, 109);
      .mixin_com(height, 86);

      background:
        url("~@/assets/images/section6/wx.png") no-repeat center top /
        100%;
    }
    .wb {
      .mixin_com(width, 101);
      .mixin_com(height, 93);

      background:
        url("~@/assets/images/section6/wb.png") no-repeat center top /
        100%;
    }
  }
  .contact {
    display: flex;
    justify-content: space-between;
    .mixin_com(width, 833);
    .mixin_com(font-size, 16);
    .mixin_com(margin-top, 52);

    color: #fff;
    text-decoration: none;
  }
  .qq-box,
  .kf-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .mixin_com(width, 364);
    .mixin_com(height, 199);

    background-color: rgba(65, 29, 19, 0.95);
  }
  .qq-box {
    .mixin_com(margin-right, 104);
  }
  .qq-item {
    .mixin_com(margin-bottom, 6);
  }
  .qq {
    .mixin_com(width, 95);
    .mixin_com(height, 107);

    background:
      url("~@/assets/images/section6/qq.png") no-repeat center top /
      100%;
  }
  .kf {
    .mixin_com(width, 95);
    .mixin_com(height, 107);

    background:
      url("~@/assets/images/section6/kf.png") no-repeat center top /
      100%;
  }
  .qq-number {
    .mixin_com(margin-left, 22);

    text-decoration: none;
  }
  .kf-qr {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .mixin_com(width, 138);
    .mixin_com(height, 138);
    .mixin_com(margin-left, 40);
    img {
      .mixin_com(width, 117);
      .mixin_com(height, 121);

      margin: 0 auto;
    }
  }
  .kf-txt {
    .mixin_com(margin-top, 10);

    line-height: 1;
    text-align: center;
  }
  .mobile {
    position: absolute;
    .mixin_com(left, 26);
    .mixin_com(bottom, 23);
    .mixin_com(width, 140);

    text-align: center;
  }
  .footer-sec {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
.about-us {
  position: absolute;
  .mixin_com(bottom, 40);

  left: 0;
  z-index: 1;
  display: block;
  width: 100%;
  .mixin_com(margin-top, 60);
  .mixin_com(font-size, 16);

  color: #fff;
  text-align: center;
}
</style>
